import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { StylistManagerPage } from './stylist-manager.page';
import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';

import { LazyLoadImageModule } from 'ng-lazyload-image';
import { StylistManagerPageRoutingModule } from './stylist-manager-routing.module';

import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        StylistManagerPage
    ],
    imports: [
        SalonMonsterLoadMaskModule,
        SalonMonsterTapRetryModule,
        CommonModule,
        LazyLoadImageModule,
        ReactiveFormsModule,
        IonicModule,
        StylistManagerPageRoutingModule
    ],
    exports: [],
    providers: []
})
export class StylistManagerPageModule {}